import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Check } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export const PaymentPage = () => {
  const [selectedPackage, setSelectedPackage] = useState("pro");
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const sessionId = params.get("session_id");
    if (sessionId) {
      pollPaymentStatus(sessionId);
    }
  }, [location]);

  const pollPaymentStatus = async (sessionId, attempts = 0) => {
    if (attempts >= 5) {
      toast.error("Verificación de pago agotada");
      return;
    }

    try {
      const response = await axios.get(`${API}/payments/status/${sessionId}`);
      if (response.data.payment_status === "paid") {
        toast.success("¡Pago exitoso! Ahora puedes agregar más propiedades.");
        setTimeout(() => navigate("/owner-dashboard"), 2000);
      } else {
        setTimeout(() => pollPaymentStatus(sessionId, attempts + 1), 2000);
      }
    } catch (error) {
      console.error("Failed to check payment status", error);
    }
  };

  const handleCheckout = async () => {
    setLoading(true);
    try {
      const originUrl = window.location.origin;
      const response = await axios.post(`${API}/payments/checkout`, {
        package: selectedPackage,
        origin_url: originUrl
      });
      
      window.location.href = response.data.url;
    } catch (error) {
      toast.error(error.response?.data?.detail || "Error al iniciar el pago");
      setLoading(false);
    }
  };

  const packages = [
    { id: "basic", name: "Básico", price: 499, properties: 5, days: 30 },
    { id: "pro", name: "Pro", price: 999, properties: 15, days: 90 },
    { id: "premium", name: "Premium", price: 1999, properties: 50, days: 365 }
  ];

  return (
    <div className="min-h-screen bg-[#F4F1DE] p-4 flex items-center justify-center">
      <div className="max-w-4xl w-full">
        <h1 className="text-4xl font-bold text-primary mb-8 text-center" data-testid="payment-title">Mejora Tu Plan</h1>

        <div className="grid md:grid-cols-3 gap-6">
          {packages.map((pkg) => (
            <Card
              key={pkg.id}
              className={`rounded-3xl cursor-pointer transition-all ${selectedPackage === pkg.id ? "ring-4 ring-primary card-shadow" : ""}`}
              onClick={() => setSelectedPackage(pkg.id)}
              data-testid={`package-${pkg.id}`}
            >
              <CardHeader className="text-center">
                <CardTitle className="text-2xl">{pkg.name}</CardTitle>
                <CardDescription className="text-3xl font-bold text-primary mt-4">${pkg.price} MXN</CardDescription>
              </CardHeader>
              <CardContent className="text-center space-y-2">
                <p className="flex items-center justify-center gap-2"><Check className="w-5 h-5 text-primary" />{pkg.properties} Propiedades</p>
                <p className="flex items-center justify-center gap-2"><Check className="w-5 h-5 text-primary" />{pkg.days} Días</p>
                <p className="flex items-center justify-center gap-2"><Check className="w-5 h-5 text-primary" />Panel de Análisis</p>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mt-8 text-center">
          <Button size="lg" onClick={handleCheckout} disabled={loading} className="rounded-full bg-primary px-12" data-testid="checkout-btn">
            {loading ? "Procesando..." : "Proceder al Pago"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentPage;
